<template>
  <div>
    <top-header-info></top-header-info>
    <top-logo state="1"></top-logo>
    <!-- <right-nav></right-nav> -->
    <home-nav></home-nav>
    <div>
      <div class="w">
        <div class="site-nav">
          <router-link :to="{name:'index'}">首页</router-link>>
          企业入驻
        </div>
        <div class="intro-wrap">
          <div class="title">
            <h2>企业入驻</h2>
            <div class="content_text">
              <p style="font-size: 18px;font-weight: bold;">允许权限</p>
              <p style="font-size: 16px;font-weight: bold;">第1条 商城服务条款的确认和接纳</p>
              <p>商城的各项电子服务的所有权和运作权归上班族数字科技有限公司所有。</p>
              <p>用户同意所有注册协议条款并完成注册程序，才能成为本商城的正式用户。</p>
              <p>如您在18周岁以下，请在父母或监护人的监护参与下使用本站。</p>
              <p style="margin-bottom: 20px;"></p>

              <p style="font-size: 16px;font-weight: bold;">第2条 权利范围</p>
              <p>本商城保留用户在中华人民共和国大陆地区法律允许的范围内注册账号、完善个人资料、浏览和分享信息、下单购物及取消订单、拒绝服务（退货、退款）、关闭用户账户、清除内容、个人隐私受保护等相应的权利。</p>
              <p style="margin-bottom: 20px;"></p>
              <p>用户不得利用商城发布、传播如下法律、法规和政策禁止的内容：</p>
              <p>(1) 反对宪法所确定的基本原则的；</p>
              <p>(2) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
              <p>(3) 损害国家荣誉和利益的；</p>
              <p>(4) 煽动民族仇恨、民族歧视，破坏民族团结的；</p>
              <p>(5) 破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
              <p>(6) 散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
              <p>(7) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
              <p>(8) 侮辱或者诽谤他人，侵害他人合法权益的；</p>
              <p>(9) 不遵守法律法规底线、社会主义制度底线、国家利益底线、公民合法权益底线、社会公共秩序底线、道德风尚底线和信息真实性底线的“七条底线”要求的；</p>
              <p>(10) 含有法律、行政法规禁止的其他内容的信息。</p>
              <p style="margin-bottom: 20px;"></p>
              <p>用户不得利用商城发布、传播如下干扰商城正常运营，以及侵犯其他用户或第三方合法权益的内容：</p>
              <p>(1) 含有辱骂、恐吓、威胁内容的；</p>
              <p>(2) 含有骚扰、垃圾广告、恶意信息、诱骗信息的；</p>
              <p>(3) 涉及他人隐私、个人信息或资料的；</p>
              <p>(4) 侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的；</p>
              <p>(5) 含有其他干扰本商城正常运营和侵犯其他用户或第三方合法权益内容的信息。</p>
              <p style="margin-bottom: 20px;"></p>

              <p style="font-size: 16px;font-weight: bold;">第3条 使用规则</p>
              <p>用户在本商城中或通过本商城所传送、发布的任何内容并不反映或代表，也不得被视为反映或代表上班族数字科技有限公司的观点、立场或政策，上班族数字科技有限公司对此不承担任何责任。</p>
              <p>用户须对商城中个人信息的真实性、合法性、无害性、准确性、有效性等全权负责，与用户所传播的信息相关的任何法律责任由用户自行承担，与上班族数字科技有限公司无关。如因此给上班族数字科技有限公司或第三方造成损害的，用户应当依法予以赔偿。</p>
              <p>用户在使用商城的过程中会遇到显示上班族数字科技有限公司和第三方供应商、合作伙伴提供的广告。除法律法规明确规定外，用户应自行对依该广告信息进行的交易负责。</p>
            </div>
            <p style="margin-bottom: 40px;"></p>
            <div>
              <p style="font-size: 18px;font-weight: bold;">隐私保护</p>
              <p style="font-size: 16px;font-weight: bold;">一． 帐号注册</p>
              <p>1. 用户在使用上班族数字科技有限公司电子商城（以下简称“商城”）前需注册一个帐号。帐号注册应当使用有效手机号，同一手机号只能注册一次。</p>
              <p>2. 为给用户提供更好的使用体验，商城数据系统会自动储存用户在注册时的个人信息，以便必要时识别用户身份并进行联系。本公司承诺对这些信息的使用将受限于第二条用户个人隐私信息保护的约束。</p>
              <p style="margin-bottom: 20px;"></p>

              <p style="font-size: 16px;font-weight: bold;">二． 用户个人隐私信息保护</p>
              <p>1. 用户在注册帐号或使用本商城的过程中，需填写或提交一些必要的个人信息。如用户提交的个人信息不完整或不符合相关法律法规，则可能导致无法使用本商城或在使用本商城的过程中受到限制。</p>
              <p>2. 用户个人信息包括：
                <br>（1）用户自行提供的个人信息（如注册时填写的手机号、使用商城时提供的真实姓名、收货地址等信息）；
                <br>（2）商城为提供服务而合法收集的用户必要个人信息（如用户浏览、购买、退换货记录信息、手机设备识别码、IP地址等）。其中个人隐私信息是指涉及用户个人身份或个人隐私的信息，比如：用户手机号、真实姓名、收货地址、手机设备识别码、IP地址等；非个人隐私信息是指用户对本商城的操作状态以及使用习惯等明确且客观反映在商城服务器端的基本记录信息、个人隐私信息范围外的其它普通信息，以及用户同意公开的上述隐私信息，比如：用户浏览、购买、退换货记录信息等。上班族数字科技有限公司保证在取得用户书面同意（上班族用户注册协议）的情况下收集、使用或公开用户的个人隐私信息。
              </p>
              <p>3. 尊重用户个人信息的私有性是上班族数字科技有限公司的一贯制度，我们将采取技术措施和其他必要措施，确保用户个人信息的安全，防止在本商城中收集的用户个人信息泄露、毁损或丢失。在发生前述情形或者商城发现存在发生前述情形的可能性时，我们将及时采取补救措施并告知用户，用户如发现存在前述情形亦可立即与上班族数字科技有限公司联系。</p>
              <p>4. 商城未经用户同意不向任何第三方公开、 透露用户个人隐私信息。但以下特定情形除外：</p>
              <p>(1) 上班族数字科技有限公司根据法律法规规定或有关执法机关的指示提供用户的个人隐私信息；</p>
              <p>(2) 由于用户将其用户密码告知他人或与他人共享注册帐户与密码，由此导致的任何个人信息的泄漏，或其他非商城自身原因导致的个人隐私信息的泄露；</p>
              <p>(3) 用户自行向第三方公开其个人隐私信息；</p>
              <p>(4) 用户与上班族数字科技有限公司及合作单位之间就用户个人隐私信息的使用公开达成约定，上班族数字科技有限公司因此向合作单位公开用户个人隐私信息；</p>
              <p>(5) 任何由于黑客攻击、电脑病毒侵入及其他不可抗力事件导致用户个人隐私信息的泄露；</p>
              <p>(6) 用户个人信息已经经过处理无法识别特定个人且不能复原。</p>
              <p>5. 用户同意上班族数字科技有限公司可在以下事项中使用个人隐私信息：</p>
              <p>(1) 商城向用户及时发送重要通知，如软件更新、本协议条款的变更；</p>
              <p>(2) 进行审计、数据分析和研究等，以改进商城的产品、服务和与用户之间的沟通；</p>
              <p>(3) 依本协议约定，商城管理、审查用户信息及进行处理措施；</p>
              <p>(4) 适用法律法规规定的其他事项。</p>
              <p>(5)除上述事项外，如未取得用户事先同意，上班族数字科技有限公司不会将用户个人隐私信息用于任何其他用途。</p>
              <p>(6)上班族数字科技有限公司保证在合法、正当与必要的原则下收集、使用或者公开用户非个人隐私信息。</p>
              <p>6. 用户有责任妥善保管注册帐号信息及帐号密码的安全，因用户保管不善可能导致遭受盗号或密码失窃，责任由用户自行承担。在用户怀疑他人使用其帐号或密码时，用户可立即通知上班族数字科技有限公司。</p>
              <p style="margin-bottom: 20px;"></p>

              <p style="font-size: 16px;font-weight: bold;">三、数据储存</p>
              <p>1. 上班族数字科技有限公司可以根据实际情况自行决定用户在本商城中数据的最长储存期限，并在服务器上为其分配数据最大存储空间等。用户可根据自己的需要自行备份本服务中的相关数据。</p>
              <p>2. 如用户停止使用本商城，上班族数字科技有限公司可以从服务器上永久地删除用户数据，并不再对用户在本商城中相关数据的储存失败负责。</p>
              <p>3. 停止使用商城后，上班族数字科技有限公司没有义务再向用户返还任何数据。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bottom-content></bottom-content>
  </div>
</template>
<script>
import TopHeaderInfo from "@/components/top-header-info";
import TopLogo from "@/components/top-logo";
import RightNav from "@/components/right-nav";
import BottomContent from "@/components/bottom-content";
import HomeNav from "@/components/home-nav";
export default {
  components: {
    TopHeaderInfo,
    TopLogo,
    RightNav,
    BottomContent,
    HomeNav
  }
};
</script>

<style lang="less" scoped>
.site-nav {
  padding: 20px 0;
  color: #999;
  font-size: 16px;
  a {
    color: #999;
  }
  a:first-child {
    color: #444;
  }
}
.intro-wrap {
  margin-bottom: 40px;
  height: 3720px;
  box-sizing: border-box;
  padding: 10px 25px 0;
  background-color: #fff;
  color: #222;
  .title {
    line-height: 42px;
    height: 42px;
    border-bottom: 2px solid #dadada;
    margin-bottom: 30px;
    h2 {
      display: inline-block;
      border-bottom: 2px solid #e2333f;
      font-size: 20px;
      font-weight: normal;
      margin: 0;
      box-sizing: border-box;
      padding: 0 20px;
    }
  }
  .content_text {
    padding: 0 20px;
    font-size: 16px;
    line-height: 36px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/introduce/agreement.vue